import { get, post } from '../shared/utils/FetchSSL.util';

const postImss = async (
	payload: {
		is_register_candidate: boolean;
		partner_address: {
			postal_code: string;
		};
	},
	tokenSession?: string,
) => {
	try {
		const data = await post(`/b2b/imss`, payload, {
			token: true,
			isNewGateway: true,
			tokenSession,
		});
		return data;
	} catch (error) {
		throw error;
	}
};

const getNss = async (tokenSession?: string) => {
	try {
		const data = await get(`/b2b/imss`, {
			isNewGateway: true,
			token: true,
			tokenSession,
		});
		return data;
	} catch (error) {
		throw error;
	}
};

export { postImss, getNss };
